/*
    Слайдер на странице кейса
*/

let sliders = [];

export class Slider {
    constructor(slider) {
        this.$slider = $(slider);
        this.slider = slider;
        this.isAwards = this.$slider.closest(".awards").length > 0;

        this.bindEvent();
        if (this.$slider.hasClass("js-slider-centered")) {
            this.initCentered();
        } else if (this.$slider.hasClass("js-slider-cases")) {
            this.initCases();
        } else {
            this.init();
        }
    }

    // Инициализация слайдера
    init() {
        this.swiper = new Swiper(this.slider, {
            loop: false,
            freeMode: true,
            slidesPerView: "auto",
            preloadImages: false,
            watchSlidesVisibility: true,
            lazy: {
                enabled: false,
                loadPrevNext: true,
                loadPrevNextAmount: 2,
                loadOnTransitionStart: true,
            },
            threshold: 10,
            roundLengths: true,
            speed: 700,
            on: {
                slideChange: () => {
                    if (this.isAwards) {
                        // Генерируем событие для аналитики
                        App.D.trigger("ga:sliderAwardsChange");
                    }
                },
            },
        });
    }

    // Инициализация слайдера с центровкой слайдов
    initCentered() {
        this.swiper = new Swiper(this.slider, {
            loop: false,
            freeMode: true,
            centeredSlides: false,
            slidesPerView: "auto",
            preloadImages: false,
            watchSlidesVisibility: true,
            spaceBetween: 16,
            lazy: {
                enabled: false,
                loadPrevNext: true,
                loadPrevNextAmount: 2,
                loadOnTransitionStart: true,
            },
            threshold: 10,
            roundLengths: true,
            speed: 700,
            breakpoints: {
                769: {
                    slidesPerView: 2,
                },
                1025: {
                    slidesPerView: "auto",
                    centeredSlides: false,
                },
            },
            on: {
                slideChange: () => {
                    if (this.isAwards) {
                        // Генерируем событие для аналитики
                        App.D.trigger("ga:sliderAwardsChange");
                    }
                },
            },
        });
    }

    // Инициализация слайдера в блоке кейсов (мобилка)
    initCases() {
        this.swiper = new Swiper(this.slider, {
            loop: false,
            freeMode: true,
            centeredSlides: false,
            slidesPerView: "auto",
            preloadImages: false,
            watchSlidesVisibility: true,
            spaceBetween: 16,
            lazy: {
                enabled: false,
                loadPrevNext: true,
                loadPrevNextAmount: 2,
                loadOnTransitionStart: true,
            },
            threshold: 10,
            roundLengths: true,
            speed: 700,
            breakpoints: {
                769: {
                    slidesPerView: 2,
                },
                1025: {
                    slidesPerView: "auto",
                    centeredSlides: false,
                },
            },
            on: {
                slideChange: () => {
                    if (this.isAwards) {
                        // Генерируем событие для аналитики
                        App.D.trigger("ga:sliderAwardsChange");
                    }
                },
            },
        });
    }

    // Включаем lazy-load и загружаем картинки
    enableLazyLoad() {
        if (this.enabledLazy) {
            return;
        }

        try {
            this.swiper.params.lazy.enabled = true;
            this.swiper.lazy.load();

            this.enabledLazy = true;
        } catch (error) {}
    }

    // По внешнему событию запускаем lazy-load
    bindEvent() {
        this.$slider.off("lazyload:start").on("lazyload:start", () => {
            this.enableLazyLoad();
        });
    }

    destroy() {
        this.swiper.destroy();
    }
}

App.W.on("barba:afterEnter", () => {
    sliders = [];

    /*
        В этот момент существует два контейнера .js-barba-container,
        поэтому надо делать какую-то выборку
    */

    App.H.find(".js-barba-container .js-slider").each(function (i, itm) {
        sliders[i] = new Slider(this);

        if (App.W.width() > 1023) {
            if ($(itm).hasClass("js-slider-awards")) {
                itm.swiper.destroy();
            }

            if ($(itm).hasClass("js-slider-cases")) {
                itm.swiper.destroy();
            }
        }
    });
});

App.W.on("barba:leave", () => {
    $.each(sliders, function () {
        try {
            this.destroy();
        } catch (error) {
            console.log(error);
        }
    });
});



// WEBPACK FOOTER //
// ./_src/js/modules/Slider.js